export enum ESubscriptionActivity {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
}

export const subscriptionActivityAsString = (activity: ESubscriptionActivity): string => {
    switch (activity) {
        case ESubscriptionActivity.ACTIVE:
            return 'Actif';
        case ESubscriptionActivity.INACTIVE:
            return 'Inactif';
        default:
            return 'Inconnu';
    }
};